import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from 'react-hot-toast';
import Layout from './pages/Layout';
import Login from './pages/Login';
import Atendimento from './pages/Atendimento';
import Canais from './pages/admin/Canais';
import Usuarios from './pages/admin/Usuarios';
import Configuracoes from './pages/admin/Configuracoes';
import Relatorios from './pages/admin/Relatorios';
import Clientes from './pages/admin/Clientes';
import Anotacoes from './pages/Anotacoes';

function AppRoutes() {
  const { usuario, carregando } = useAuth();

  if (carregando) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', fontSize:14 }}>
      Carregando...
    </div>
  );

  if (!usuario) return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );

  // Admin global OU admin de pelo menos 1 canal
  const podeAdministrar = usuario.perfil === 'admin' || (usuario.canaisAdmin && usuario.canaisAdmin.length > 0);
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/atendimento" />} />
        <Route path="/atendimento" element={<Atendimento />} />
        <Route path="/admin/canais" element={podeAdministrar ? <Canais /> : <Navigate to="/atendimento" />} />
        <Route path="/admin/usuarios" element={podeAdministrar ? <Usuarios /> : <Navigate to="/atendimento" />} />
        <Route path="/admin/configuracoes" element={usuario.perfil === 'admin' ? <Configuracoes /> : <Navigate to="/atendimento" />} />
        <Route path="/admin/relatorios" element={podeAdministrar ? <Relatorios /> : <Navigate to="/atendimento" />} />
        <Route path="/admin/clientes" element={podeAdministrar ? <Clientes /> : <Navigate to="/atendimento" />} />
        <Route path="/anotacoes" element={<Anotacoes />} />
        <Route path="*" element={<Navigate to="/atendimento" />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
